/* I Luminari 3D — small details of light: Lumi the mascot, the "lights off" easter egg, the tab title,
   the cart glow after adding a product and the evening note in the footer. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var now = new Date();
  var hour = now.getHours();
  var isNight = hour >= 21 || hour < 7;
  var isBirthday = now.getMonth() === 7 && now.getDate() === 16;
  // Texts and switches from the theme settings "Dettagli di luce" (snippet lumi.liquid).
  var cfg = {};
  try { cfg = JSON.parse((document.querySelector('[data-luce]') || {}).textContent || '{}'); } catch (e) {}
  var on = function (k) { return cfg[k] !== false; };

  // Console hello for the curious.
  try { console.log('%cCiao, sono Lumi. Ti piace curiosare nel codice? Anche a noi. Scrivici: info@iluminari3d.com', 'color:#C8A55E;font-weight:600'); } catch (e) {}

  /* ---------- Tab title: "the light is still on" while the visitor is on another tab ---------- */
  var title = document.title;
  // A small sign in front of the page name, not a sentence in its place: the browser history keeps the last title
  // a page had, and it must stay the real one. The real title also comes back as the page is left.
  var mark = (cfg.tabText || '•').trim();
  if (on('tab') && mark) {
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { title = document.title; document.title = mark + ' ' + title; }
      else document.title = title;
    });
    window.addEventListener('pagehide', function () { document.title = title; });
  }

  /* ---------- Evening note in the footer ---------- */
  if (isNight && on('night')) {
    var foot = document.querySelector('footer.foot');
    if (foot) {
      var note = document.createElement('p');
      note.className = 'lu-night mono';
      note.textContent = cfg.nightText || 'Il laboratorio è chiuso, ma qui la luce resta accesa.';
      foot.appendChild(note);
    }
  }

  /* ---------- Cart glow: the cart icon lights up on the page reached after "Add to cart" ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-add], form[action*="/cart/add"] [type="submit"]')) store.set('lu-added', String(Date.now()));
  }, true);
  var added = Number(store.get('lu-added') || 0);
  if (added && Date.now() - added < 20000 && on('cartGlow')) {
    store.set('lu-added', '');
    var cartIcon = document.querySelector('.nav a[href$="/cart"]');
    if (cartIcon) {
      cartIcon.classList.add('lu-cart-glow');
      setTimeout(function () { cartIcon.classList.remove('lu-cart-glow'); }, 2400);
    }
  }

  /* ---------- Lights off: hold the logo (or type "luce") and the page goes dark, the pointer becomes a torch ---------- */
  var dark = null;
  function lightsOff() {
    if (dark || !on('dark')) return;
    dark = document.createElement('div');
    dark.className = 'lu-dark';
    dark.setAttribute('role', 'dialog');
    dark.setAttribute('aria-label', 'Luci spente');
    var li = document.querySelector('[data-lumi] .lumi__img');
    var wink = li && ((document.documentElement.classList.contains('xmas') && li.getAttribute('data-xwink')) || li.getAttribute('data-wink'));
    dark.innerHTML = '<div class="lu-dark__msg">' +
      (wink ? '<img src="' + wink + '" alt="" width="70" height="100">' : '') +
      '<p class="mono"></p><p class="lu-dark__big"></p>' +
      '<button type="button" class="btn btn-gold" data-dark-close></button></div>';
    dark.querySelector('.mono').textContent = cfg.darkTitle || 'Ci hai trovato.';
    dark.querySelector('.lu-dark__big').textContent = cfg.darkText || 'La luce, qui, la porti tu.';
    dark.querySelector('[data-dark-close]').textContent = cfg.darkButton || 'Riaccendi';
    document.body.appendChild(dark);
    var move = function (x, y) { dark.style.setProperty('--x', x + 'px'); dark.style.setProperty('--y', y + 'px'); };
    move(innerWidth / 2, innerHeight / 2);
    dark.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); });
    dark.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
    requestAnimationFrame(function () { dark.classList.add('is-on'); });
    dark.querySelector('[data-dark-close]').addEventListener('click', lightsOn);
    dark.querySelector('[data-dark-close]').focus({ preventScroll: true });
    document.addEventListener('keydown', escClose);
  }
  function lightsOn() {
    if (!dark) return;
    var d = dark; dark = null;
    d.classList.remove('is-on');
    document.removeEventListener('keydown', escClose);
    setTimeout(function () { d.remove(); }, reduce ? 0 : 500);
  }
  function escClose(e) { if (e.key === 'Escape') lightsOn(); }

  /* On phones a long press normally opens the link menu (Android) or the link preview (iOS), which cancels the
     pointer events: there the long press itself (contextmenu on Android, a touch timer on iOS) switches the light off. */
  var logo = on('dark') && document.querySelector('.nav-logo');
  if (logo) {
    var holdTimer = null, held = false;
    var start = function () { held = false; clearTimeout(holdTimer); holdTimer = setTimeout(function () { held = true; lightsOff(); }, 800); };
    var stop = function () { clearTimeout(holdTimer); };
    logo.addEventListener('mousedown', start);
    logo.addEventListener('mouseup', stop);
    logo.addEventListener('mouseleave', stop);
    logo.addEventListener('touchstart', start, { passive: true });
    logo.addEventListener('touchend', function (e) { stop(); if (held) e.preventDefault(); });
    logo.addEventListener('touchmove', stop, { passive: true });
    logo.addEventListener('contextmenu', function (e) { e.preventDefault(); clearTimeout(holdTimer); if (!held) { held = true; lightsOff(); } });
    logo.addEventListener('click', function (e) { if (held) { e.preventDefault(); held = false; } });
    logo.setAttribute('draggable', 'false');
    logo.querySelectorAll('img').forEach(function (i) { i.setAttribute('draggable', 'false'); });
  }
  var typed = '';
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (!e.key || e.key.length !== 1) return;
    typed = (typed + e.key.toLowerCase()).slice(-4);
    if (typed === 'luce') { typed = ''; lightsOff(); }
  });

  /* ---------- Lumi ---------- */
  var lumi = document.querySelector('[data-lumi]');
  var tipsEl = document.querySelector('[data-lumi-tips]');
  if (!lumi || !tipsEl) return;
  var tips = {};
  try { tips = JSON.parse(tipsEl.textContent); } catch (e) { return; }
  // Lists come from textareas, one tip per line: drop the empty lines.
  Object.keys(tips).forEach(function (k) {
    if (Array.isArray(tips[k])) tips[k] = tips[k].map(function (t) { return String(t).trim(); }).filter(Boolean);
  });

  // Fewer appearances on phones, where the screen is small: theme settings "Quante volte al massimo per visita".
  var phone = window.matchMedia('(max-width: 899px)').matches;
  var maxShows = Number(lumi.getAttribute(phone ? 'data-max-mobile' : 'data-max'));
  if (isNaN(maxShows) || lumi.getAttribute(phone ? 'data-max-mobile' : 'data-max') === '') maxShows = phone ? 1 : 3;
  var shown = Number(store.get('lumi-count') || 0);
  if ((store.get('lumi-off') || shown >= maxShows) && !lumi.querySelector('[data-lumi-posted]')) return;

  var img = lumi.querySelector('.lumi__img');
  var text = lumi.querySelector('[data-lumi-text]');
  var cta = lumi.querySelector('[data-lumi-cta]');
  var ctx = lumi.getAttribute('data-ctx') || 'general';
  var page = lumi.getAttribute('data-page');
  var free = Number(lumi.getAttribute('data-free')) || 129;
  var delay = Math.max(8, Number(lumi.getAttribute('data-delay')) || 25) * 1000 * (phone ? 2 : 1);
  if (page === 'cart') delay = phone ? 10000 : 6000;
  if (lumi.querySelector('[data-lumi-posted]')) delay = 1200;

  function pose(name) {
    var x = document.documentElement.classList.contains('xmas') ? img.getAttribute('data-x' + name) : null;
    return x || img.getAttribute('data-' + name);
  }
  function nextOf(list, key) {
    var i = Number(store.get(key) || 0);
    store.set(key, String(i + 1));
    return list[i % list.length];
  }
  function money(cents) {
    try { return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  var form = lumi.querySelector('[data-lumi-form]');
  var posted = !!lumi.querySelector('[data-lumi-posted]');
  var shipBy = lumi.getAttribute('data-ship-by') || '';
  function xmasDate() {
    // In the Christmas season, until the last safe day for delivery (theme setting "Ordina entro").
    if (!document.documentElement.classList.contains('xmas') || !/^\d{4}-\d{2}-\d{2}$/.test(shipBy)) return null;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var today = now.getFullYear() + '-' + p(now.getMonth() + 1) + '-' + p(now.getDate());
    if (today > shipBy) return null;
    var d = new Date(shipBy + 'T12:00:00');
    return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long' });
  }

  // Returns a promise of { t: text, pose, cta: { label, href } | { label, add: true }, form: true }
  function pickTip() {
    if (posted) { store.set('lumi-news', '1'); return Promise.resolve({ t: tips.newsletter_ok, pose: 'hi' }); }
    if (isBirthday && !store.get('lumi-bday')) { store.set('lumi-bday', '1'); return Promise.resolve({ t: tips.birthday, pose: 'tip' }); }
    if (isNight && !store.get('lumi-night')) { store.set('lumi-night', '1'); return Promise.resolve({ t: tips.night, pose: 'night' }); }
    if (page === 'cart') {
      // Free shipping above the threshold of the general shipping profile; crowns and doormats ship on their own terms.
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var special = (c.items || []).some(function (it) { return /coron|zerbin/.test(it.handle || ''); });
        if (!c.item_count || special) return tips.cart.length ? { t: nextOf(tips.cart, 'lumi-i-cart'), pose: 'tip' } : null;
        var left = free * 100 - c.total_price;
        if (left <= 0) return { t: tips.free_done, pose: 'hi' };
        return { t: tips.free_left.replace('{left}', money(left)), pose: 'tip', cta: { label: 'Idee piccole da aggiungere', href: '/collections/all?sort_by=price-ascending' } };
      }).catch(function () { return tips.cart.length ? { t: nextOf(tips.cart, 'lumi-i-cart'), pose: 'tip' } : null; });
    }
    var xd = xmasDate();
    if (xd && page === 'product' && !store.get('lumi-xmas')) {
      store.set('lumi-xmas', '1');
      var b = document.querySelector('[data-add]:not([disabled])');
      return Promise.resolve({ t: tips.xmas.replace('{date}', xd), pose: 'tip', cta: b ? { label: 'Aggiungi al carrello', add: true } : null });
    }
    // The newsletter invite: from the second appearance, outside product and cart pages, once per visit.
    if (form && shown > 0 && page !== 'product' && !store.get('lumi-news') && !localStorage_get('lumi-subscribed')) {
      store.set('lumi-news', '1');
      return Promise.resolve({ t: tips.newsletter, pose: 'tip', form: true });
    }
    var list = (tips[ctx] && tips[ctx].length ? tips[ctx] : tips.general) || [];
    var addBtn = document.querySelector('[data-add]:not([disabled])');
    if (page === 'product' && addBtn && shown > 0 && tips.product_buy && tips.product_buy.length) {
      return Promise.resolve({ t: nextOf(tips.product_buy, 'lumi-i-buy'), pose: 'tip', cta: { label: 'Aggiungi al carrello', add: true } });
    }
    if (!list.length) return Promise.resolve(null);
    return Promise.resolve({ t: nextOf(list, 'lumi-i-' + ctx), pose: shown === 0 ? 'hi' : 'tip' });
  }

  function localStorage_get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  if (form) form.addEventListener('submit', function () { try { localStorage.setItem('lumi-subscribed', '1'); } catch (e) {} });
  var idle = null, done = false;
  function arm() {
    clearTimeout(idle);
    if (done) return;
    idle = setTimeout(show, delay);
  }
  function show() {
    // Not while a menu, a cart drawer or the opening animation is covering the page.
    if (document.hidden || document.documentElement.classList.contains('intro-on') || document.querySelector('.lu-dark, .drawer.is-open, [aria-modal="true"]:not([hidden])')) { arm(); return; }
    done = true;
    pickTip().then(function (tip) {
      if (!tip || !tip.t) return;
      shown += 1; store.set('lumi-count', String(shown));
      img.src = pose(tip.pose) || img.src;
      text.textContent = tip.t;
      if (tip.cta) {
        cta.textContent = tip.cta.label;
        cta.href = tip.cta.href || '#';
        cta.dataset.add = tip.cta.add ? '1' : '';
        cta.hidden = false;
      } else cta.hidden = true;
      if (form) form.hidden = !tip.form;
      lumi.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { lumi.classList.add('is-in'); }); });
    });
  }
  // Lumi stays until he is closed.
  function hide() {
    lumi.classList.remove('is-in');
    setTimeout(function () { lumi.hidden = true; }, reduce ? 0 : 600);
  }
  lumi.querySelector('[data-lumi-close]').addEventListener('click', function () { store.set('lumi-off', '1'); hide(); });
  cta.addEventListener('click', function (e) {
    if (!cta.dataset.add) return;
    e.preventDefault();
    var btn = document.querySelector('[data-add]:not([disabled])');
    if (!btn) return;
    hide();
    btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    btn.classList.add('lu-pulse');
    setTimeout(function () { btn.classList.remove('lu-pulse'); }, 2600);
  });

  ['scroll', 'pointermove', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, function () { if (!done) arm(); }, { passive: true });
  });
  arm();
})();

/* ---------- Lumi AI chat (only when the theme setting "Indirizzo di Lumi AI" is filled) ---------- */
(function () {
  'use strict';
  var lumi = document.querySelector('[data-lumi]');
  var chat = document.querySelector('[data-lumi-chat]');
  var launch = document.querySelector('[data-lumi-launch]');
  if (!lumi || !chat || !launch) return;
  var endpoint = lumi.getAttribute('data-ai');
  if (!endpoint) return;

  var log = chat.querySelector('[data-lumi-log]');
  var form = chat.querySelector('[data-lumi-chat-form]');
  var input = form.querySelector('input');
  var sendBtn = form.querySelector('button');
  var KEY = 'lumi-chat';
  var history = [];
  try { history = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { history = []; }

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(history.slice(-12))); } catch (e) {} }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Lumi's text: escaped, then only links to the shop and **bold** are turned into HTML.
  function format(t) {
    var h = esc(t);
    h = h.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    h = h.replace(/\[([^\]]+)\]\((https:\/\/(?:www\.)?iluminari3d\.com[^\s)]*)\)/g, '<a href="$2">$1</a>');
    h = h.replace(/(^|[\s(])(https:\/\/(?:www\.)?iluminari3d\.com\/[^\s)<]*)/g, function (m, pre, url) {
      var label = url.indexOf('/products/') > -1 ? 'Vedi il prodotto' : 'Apri la pagina';
      return pre + '<a href="' + url + '">' + label + ' →</a>';
    });
    h = h.replace(/(\b339 ?464 ?5623\b)/g, '<a href="https://wa.me/393394645623" target="_blank" rel="noopener">$1</a>');
    return h.replace(/\n/g, '<br>');
  }
  function add(role, content, temp) {
    var b = document.createElement('div');
    b.className = 'lumi-msg lumi-msg--' + (role === 'user' ? 'me' : 'lumi') + (temp ? ' is-typing' : '');
    if (role === 'user') b.textContent = content; else b.innerHTML = temp ? '<span></span><span></span><span></span>' : format(content);
    log.appendChild(b);
    log.scrollTop = log.scrollHeight;
    return b;
  }
  function render() {
    log.innerHTML = '';
    var welcome = '';
    try { welcome = JSON.parse(document.querySelector('[data-lumi-tips]').textContent).welcome || ''; } catch (e) {}
    add('assistant', welcome || 'Ciao, sono Lumi! Chiedimi dei nostri prodotti, dei materiali, dei tempi o delle spedizioni. Ti aiuto anche a scegliere un regalo.');
    history.forEach(function (m) { add(m.role, m.content); });
  }
  function open() {
    var peek = document.querySelector('[data-lumi]');
    if (peek) { peek.classList.remove('is-in'); peek.hidden = true; }
    if (!log.childNodes.length) render();
    chat.hidden = false;
    launch.hidden = true;
    document.documentElement.classList.add('lumi-chat-open');
    // The phone's back button closes the chat instead of leaving the page: one history step while it is open.
    try { if (!(window.history.state && window.history.state.lumiChat)) window.history.pushState({ lumiChat: true }, ''); } catch (e) {}
    requestAnimationFrame(function () { chat.classList.add('is-open'); input.focus({ preventScroll: true }); });
  }
  function close(fromBack) {
    if (chat.hidden) return;
    // Closed with the X or Esc: drop the history step added on open, so "back" then leaves the page as usual.
    if (fromBack !== true) { try { if (window.history.state && window.history.state.lumiChat) window.history.back(); } catch (e) {} }
    chat.classList.remove('is-open');
    document.documentElement.classList.remove('lumi-chat-open');
    setTimeout(function () { chat.hidden = true; launch.hidden = false; }, 250);
  }

  window.addEventListener('popstate', function () { if (!chat.hidden) close(true); });
  // Reopened page with the chat step still on top (e.g. after a reload): leave it closed and step past it.
  try { if (window.history.state && window.history.state.lumiChat) window.history.replaceState(null, ''); } catch (e) {}
  launch.hidden = document.documentElement.classList.contains('intro-on');
  launch.addEventListener('click', open);
  var ask = document.querySelector('[data-lumi-ask]');
  if (ask) ask.addEventListener('click', open);
  chat.querySelector('[data-lumi-chat-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !chat.hidden) close(); });
  // The launcher waits for the black opening of the home page to finish.
  new MutationObserver(function () {
    if (chat.hidden) launch.hidden = document.documentElement.classList.contains('intro-on');
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q || sendBtn.disabled) return;
    input.value = '';
    history.push({ role: 'user', content: q });
    add('user', q);
    var typing = add('assistant', '', true);
    sendBtn.disabled = true;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history.slice(-12), page: document.title + ' — ' + location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      var reply = (d && d.reply) || 'Ops, mi si è fulminato un filo! Riprova tra poco, oppure scrivici su WhatsApp al 339 464 5623.';
      typing.remove();
      history.push({ role: 'assistant', content: reply });
      add('assistant', reply);
      save();
    }).catch(function () {
      typing.remove();
      history.pop();
      add('assistant', 'Non riesco a collegarmi in questo momento. Riprova tra poco, oppure scrivici su WhatsApp al 339 464 5623.');
    }).then(function () { sendBtn.disabled = false; input.focus({ preventScroll: true }); });
  });
})();
